import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Save, Play, Plus } from 'lucide-react'

interface FlowToolbarProps {
  nombre: string
  onNombreChange: (nombre: string) => void
  onNombreBlur: () => void
  onAddEnvio: () => void
  onAddCondicion: () => void
  onSave: () => void
  onExecute: () => void
  isSaving: boolean
  isExecuting: boolean
}

export function FlowToolbar({
  nombre,
  onNombreChange,
  onNombreBlur,
  onAddEnvio,
  onAddCondicion,
  onSave,
  onExecute,
  isSaving,
  isExecuting,
}: FlowToolbarProps) {
  return (
    <div className="flex items-center gap-2 p-3 border-b bg-white dark:bg-background">
      <Input
        value={nombre}
        onChange={(e) => onNombreChange(e.target.value)}
        onBlur={onNombreBlur}
        placeholder="Nombre del flujo"
        className="h-8 w-56 text-sm font-semibold"
      />
      <span className="text-sm font-medium text-gray-600 dark:text-gray-400 ml-3 mr-1">Agregar nodo:</span>
      <Button size="sm" variant="outline" onClick={onAddEnvio}>
        <Plus size={14} className="mr-1" /> Envío Email
      </Button>
      <Button size="sm" variant="outline" onClick={onAddCondicion}>
        <Plus size={14} className="mr-1" /> Condición
      </Button>
      <div className="ml-auto flex gap-2">
        <Button size="sm" variant="outline" onClick={onSave} disabled={isSaving}>
          <Save size={14} className="mr-1" />
          {isSaving ? 'Guardando...' : 'Guardar'}
        </Button>
        <Button size="sm" onClick={onExecute} disabled={isExecuting}
          className="bg-blue-800 hover:bg-blue-900 text-white">
          <Play size={14} className="mr-1" />
          {isExecuting ? 'Ejecutando...' : 'Ejecutar flujo'}
        </Button>
      </div>
    </div>
  )
}
